{
  "#APP_OVERVIEW": {
    "ALL_APPLICATIONS": "All Applications",
    "MY_APPLICATIONS": "My Applications",
    "FAVORITES": "Favorites",
    "SEARCH": "Search all applications...",
    "GRID": "Grid View",
    "LIST": "List View",
    "INFO_TOOLTIP": "Show module info",
    "INFO": {
      "module": "Module",
      "library": "Library",
      "route": "Route",
      "permission": "Permission",
      "group": "Group"
    },
    "CONFIG_TITLE": "Configuration",
    "CONFIG_DEFAULT": "Default",
    "CONFIG_SOURCE_APP": "App",
    "REMOTE_CONFIG_TITLE": "Server configuration (WebAppVw)",
    "REMOTE_CONFIG_LOADING": "Loading …",
    "REMOTE_CONFIG_ERROR": "Configuration could not be loaded",
    "REMOTE_CONFIG_MISSING": "No entries on the server",
    "BACKEND_TITLE": "Backend services",
    "BACKEND_SESSION": "This session",
    "BACKEND_WEBSERVICE": "Webservice",
    "BACKEND_EMPTY": "No calls yet – open the module to record them",
    "PERMISSIONS_TITLE": "Permissions",
    "PERMISSION_TILE": "Show module",
    "PERMISSION_GRANTED": "Granted",
    "PERMISSION_DENIED": "Missing",
    "PERMISSION_LOCALHOST": "Always granted on localhost",
    "PERMISSION_COPY": "Copy permission",
    "YES": "Yes",
    "NO": "No",
    "NOT_SET": "not set",
    "CONFIG": {}
  }
}
